import { render, staticRenderFns } from "./DD.vue?vue&type=template&id=52127e2f&scoped=true&"
import script from "./DD.vue?vue&type=script&lang=js&"
export * from "./DD.vue?vue&type=script&lang=js&"
import style0 from "./DD.vue?vue&type=style&index=0&id=52127e2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52127e2f",
  null
  
)

export default component.exports